webpackJsonp([216427503475386],{

/***/ 782:
/***/ (function(module, exports) {

	module.exports = {"data":{"contributionsJson":{"name":"installation","www_url":"http://www.chutiwongpeti.info/","thema":"blind love","issue_month":"September","issue_year":2005,"issue_date":200509,"artist":"Sarawut","location":"Japan","email":"utopia1998@hotmail.com","id":"contribution_137","media_type":"still_image","position_in_section":3,"media_uri":"media/2005/September/still_image/DVD-02.jpg","media_th_uri":"media/2005/September/still_image/tn_DVD-02.jpg","still_image_count":9,"moving_image_count":1,"textz_count":1,"soundz_count":0}},"pathContext":{"id":"contribution_137"}}

/***/ })

});


// WEBPACK FOOTER //
// path---issue-200509-still-image-3-1a32fb3b4524a417f90c.js